var render = function render(_c,_vm){return _c('div',{class:`announce-type-area-cell d-flex align-center justify-center ${_vm.$options.computedAllColorClass(
    _vm.props,
  )}`},[_c('div',{staticClass:"announce-type-area-cell-inner text-center"},[_vm._v(" "+_vm._s(_vm.props.status)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }